import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { FormControl } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-assign-driver',
  templateUrl: './assign-driver.component.html',
  styleUrls: ['./assign-driver.component.css']
})
export class AssignDriverComponent implements OnInit {
  driverForm: FormGroup;
  selectedValue:string=""
  driversList: any[] = [];
  driversList1: any[] = [];
  @Input()
  tasks: any = {};
  assignedtoControl = new FormControl();
  myControl = new FormControl();
  options: string[] = ['One', 'Two', 'Three'];
  filteredOptions: Observable<string[]>;
  recordCount$: Observable<number>;
  @Output()
  driverAssignedEvent:EventEmitter<any> = new EventEmitter<any>();
  userData: any;
  orgId: any;
  reassignDriver:boolean=false;
  assignDriver:boolean=false;
  filteredDrivers: any[] = [];
  driverID: any;
  constructor(private commonService: CommonService,
    private fb: FormBuilder) { 
      this.driverForm = this.fb.group({
        escort: [false],
        planned_emp: [0],
        actual_emp: [0],
        remarks: [''],
        assignedto: [0],
        assignedto1:[0],//custome vivek code
        status: ['assigned']
      });
    }

  ngOnInit(): void {
    let userDataObj = localStorage.getItem('userData');
    if (userDataObj) {
      try {
        this.userData = JSON.parse(userDataObj);
       
        console.log('Org Id =>',this.userData.id)
        if(this.userData.attributes.role === 'admin'){
       this.orgId=this.userData.id;
      }
      else{
        this.orgId = this.userData.orgId;
      }
      } catch (error) {}
    }


    this.getDriversList();
    console.log('task details1=>',this.tasks);
    if(this.tasks.attributes.escort === "0"){
      console.log('escort=>',this.tasks.attributes.escort)
      this.selectedValue="false"
    }
    else{
      console.log('escort=>',this.tasks.attributes.escort)
      this.selectedValue="true"
    }
    if(this.tasks.assignedto == 0){
       this.assignDriver = true;
    }
    else{
      this.reassignDriver =true;
    }
  
    
 
   
  }

  filteredOption1()
  {
  this.filteredOptions = 
  this.myControl.valueChanges
  .pipe(
    startWith(''),
    map(value => this._filter(value))
  );
  console.log('values=>', this.myControl.valueChanges)
  }
  private _filter(value: string): string[] {
    let abc;
    if(value != "")
    {
    const filterValue = value.toLowerCase();
   
     abc=  this.driversList
      .filter(driver => driver.attributes.did.toLowerCase().includes(filterValue) || driver.name.toLowerCase().includes(filterValue))
      .map(driver => {
        const id = driver.id; // Retrieve the id from the iterator value
        this.driverID = id; // Set this.driverID to the retrieved id
        return driver.attributes.did + ' ' + driver.name;
    });
    }
      else
      {
       abc=  this.driversList
          .map(driver => driver.attributes.did + ' ' + driver.name);
      }
      console.log('abc',abc)
      return abc;
  }


  // private _filter(value: any): any[] {
  //   const filterValue = value.toLowerCase();

  //   return this.driversList.filter(option => option.toLowerCase().includes(filterValue));
  // }

  // getDriversList() {
  //   this.commonService.getRequest('users', []).then((resp: any) => {
  //     // console.log("tasks data");
  //     // console.log(resp);
  //     if (resp?.status) {
  //         this.driversList = resp.data.filter(x => x.attributes.role == 'driver' && x.attributes?.status != 'offline');
  //         if (this.driversList.length > 0) {
  //           this.driverForm.patchValue({
  //             assignedto: this.driversList[0].id
  //           })
  //         }
  //     }
  //   });
  // }
//custom vivek code
getDriversList() {

  this.commonService.getRequest(`users?orgId=${this.orgId}`, []).then((resp: any) => {
    if (resp?.status) {
        this.driversList = resp.data.filter(x => x.attributes.role == 'driver');
        if (this.driversList.length > 0) {
          this.driverForm.patchValue({
            assignedto: this.driversList[0].id,
            assignedto1:this.driversList[0].name,
          })
        }
    }
    console.log('driverList',this.driversList)
  });
}
  submitFormData() {
 
    this.tasks.status = this.driverForm.value.status;
    this.tasks.assignedto = this.driverForm.value.assignedto;
    this.tasks.attributes.remarks = this.driverForm.value.remarks;
    this.tasks.attributes.planned_emp = this.driverForm.value.planned_emp;
    this.tasks.attributes.actual_emp = this.driverForm.value.actual_emp;
    this.tasks.attributes.escort = this.driverForm.value.escort == 'true'?true:false;
    this.commonService
    .putRequest(`traccartasks/${this.tasks.id}`, this.tasks)
    .then((resp: any) => {
      if (resp?.status) {
        this.driverAssignedEvent.emit(resp);
        this.commonService.commonModel.next(false);
        Swal.fire({
          icon: "success",
          title: `Driver ${this.driverForm.value.status} successfull`,
          showConfirmButton: false,
          timer: 1500,
        });        
      }      
    }, err => {
      Swal.fire({
        icon: "error",
        title: "Something Went Wrong",
        showConfirmButton: false,
        timer: 1500,
      });
    });
  }
  //added by vivek
  onValueChange() {
    console.log('Selected value: ', this.selectedValue);
  }
  closeForm() {
    this.commonService.commonModel.next(false);
  }
}
